import { render, staticRenderFns } from "./ListaPlano.vue?vue&type=template&id=f30d1614&scoped=true"
import script from "./ListaPlano.vue?vue&type=script&lang=ts"
export * from "./ListaPlano.vue?vue&type=script&lang=ts"
import style0 from "./ListaPlano.vue?vue&type=style&index=0&id=f30d1614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30d1614",
  null
  
)

export default component.exports